import { render, staticRenderFns } from "./RevenueChart.vue?vue&type=template&id=fc20b234&scoped=true"
import script from "./RevenueChart.vue?vue&type=script&lang=js"
export * from "./RevenueChart.vue?vue&type=script&lang=js"
import style0 from "./RevenueChart.vue?vue&type=style&index=0&id=fc20b234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc20b234",
  null
  
)

export default component.exports